module.exports = __webpack_public_path__ + "img/footerPatternv2.fad56c24.svg";